import React, { useRef } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import { apiAdminConfig } from "../../utils/api";
import useToast from "../../provider/Toast/useToast";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SendNotification = () => {
  const toast = useToast();
  const validationSchema = yup.object().shape({
    title: yup.string().required("Title is a required"),
    content: yup.string().required("Notification Content is a required"),
    // date: yup.string("Date is a required").required("Date is a required"),
    // time: yup.mixed("Time is a required").required("Time is a required"),
  });
  const { handleSubmit, handleChange, values, errors, touched, resetForm, setFieldValue } =
    useFormik({
      initialValues: {
        title: "",
        content: "",
        link : "",
        // date: "",
        // time: "",
      },
      validationSchema,
      onSubmit: async () => {
        // let newDate = "";
        // let newTime = "";
        // if (values?.date) {
        //   const getDate = moment(values?.date).format("YYYY-MM-DD");
        //   const getTime = moment(values?.date).format("h:mm:ss");
        //   newDate = `${getDate}`;
        //   newTime = `${getTime}`;
        // }

        const data = {
          title: values.title,
          content: values.content,
          link: values.link,
          // date: newDate,
          // time: newTime
        }

        await apiAdminConfig.post(`admin/pushnotify/add`, data).then((response) => {
          if (response?.data.status) {
            resetForm();
            toast({
              message: response?.data?.message,
              bg: 'success'
            });
          } else {
            toast({
              message: response?.data?.message,
              bg: 'danger'
            });
          }
        }).catch((error) => {
          const { response } = error;
          console.log("eventError", error)
          toast({
            message: response?.data?.message,
            bg: "danger",
          });
        })
      },
    });


  return (
    <main id="send_notification">
      <Container className="admin_padding">
        <div className="admin_add_form">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "14px 0",
              alignItems: "center",
            }}
            className="table-hader-container"
          >
            <div>
              <h3 className="table-hader-name">Send push notification</h3>
            </div>
            <Link to="/" className="page_add_btn">
              Back
            </Link>
          </div>
          <Row>
            <Col>
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        TITLE<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        value={values.title}
                        onChange={handleChange}
                        isInvalid={!!errors.title && touched.title}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.title}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>
                      CONTENT
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="content"
                      value={values.content}
                      onChange={handleChange}
                      isInvalid={
                        !!errors.content && touched.content
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.content}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        LINK
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="link"
                        value={values.link}
                        onChange={handleChange}
                        // isInvalid={!!errors.title && touched.title}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">
                  {/* <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        DATE<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="date"
                        min={new Date().toISOString().split('T')[0]}
                        value={values.date}
                        onChange={handleChange}
                        isInvalid={!!errors.date && touched.date}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.date}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                  {/* <Col>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>
                        DATE & TIME
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        as={DatePicker}
                        dateFormat="yyyy-MM-dd, h:mm aa"
                        selected={values.date}
                        onChange={(e) => setFieldValue("date", e)}
                        isInvalid={!!errors.date && touched.date}
                        showTimeSelect
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.date}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                </Row>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  className="footer-btns"
                >
                  <Button type="submit" className="input_file_button">
                    Send Now
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </main>
  );
};

export default SendNotification;
